import React from 'react';
import { TranslationsContext } from './translations-context';
export function useTranslate() {
    const ctx = React.useContext(TranslationsContext);
    return ctx.t;
}
//# sourceMappingURL=use-translate.js.map